export interface CookieOptions {
    days?: number;
    path?: string;
    sameSite?: 'Strict' | 'Lax' | 'None';
}

const DEFAULT_EXPIRY_DAYS = 365;
const DEFAULT_PATH = '/';
const DEFAULT_SAME_SITE: CookieOptions['sameSite'] = 'Lax';

export function setCookie(
    name: string,
    value: string | Record<string, unknown>,
    options?: CookieOptions,
): void {
    const cookieValue = typeof value === 'string' ? value : JSON.stringify(value);
    const expiryDays = options?.days ?? DEFAULT_EXPIRY_DAYS;
    const path = options?.path ?? DEFAULT_PATH;
    const sameSite = options?.sameSite ?? DEFAULT_SAME_SITE;

    const expires = new Date();
    expires.setTime(expires.getTime() + expiryDays * 24 * 60 * 60 * 1000);

    document.cookie = `${name}=${encodeURIComponent(cookieValue)};expires=${expires.toUTCString()};path=${path};SameSite=${sameSite}`;
}

function getCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');

    const found = cookies.find((cookie) => cookie.trim().indexOf(nameEQ) === 0);
    if (!found) return null;

    try {
        return decodeURIComponent(found.trim().substring(nameEQ.length));
    } catch {
        return null;
    }
}

export function getCookieJSON<T = Record<string, unknown>>(name: string): T | null {
    try {
        const value = getCookie(name);
        if (!value) return null;
        return JSON.parse(value) as T;
    } catch {
        return null;
    }
}
